import apiService from '@/services/api'

export interface ApiResponse<T> {
  success: boolean
  data: T
  message?: string
  meta?: { page: number; limit: number; total: number; totalPages: number }
}

export interface Vendor {
  id: string
  name: string
  contactPerson?: string | null
  email?: string | null
  phone?: string | null
  address?: string | null
  [key: string]: unknown
}

export interface VendorsListResponse {
  vendors: Vendor[]
  meta: { page: number; limit: number; total: number; totalPages: number }
}

export async function getVendors(params?: {
  page?: number
  limit?: number
  search?: string
}): Promise<VendorsListResponse> {
  const searchParams = new URLSearchParams()
  if (params?.page != null) searchParams.set('page', String(params.page))
  if (params?.limit != null) searchParams.set('limit', String(params.limit))
  if (params?.search) searchParams.set('search', params.search)
  const query = searchParams.toString()
  const url = query ? `/vendors?${query}` : '/vendors'
  const response = await apiService.get<ApiResponse<VendorsListResponse>>(url)
  if (!response.success) throw new Error(response.message || 'Failed to fetch vendors')
  return response.data
}

export interface CreateVendorPayload {
  name: string
  contactPerson?: string
  email?: string
  phone?: string
  address?: string
  bankDetails?: {
    accountName?: string
    accountNumber?: string
    bankName?: string
    ifscCode?: string
    swiftCode?: string
  }
}

export async function createVendor(payload: CreateVendorPayload): Promise<Vendor> {
  const response = await apiService.post<ApiResponse<Vendor>>('/vendors', payload)
  if (!response.success) throw new Error(response.message || 'Failed to create vendor')
  return response.data
}
